import menuConfig from './menu-config';

export const getTopTabs = () => ([
	{ label: '首页', routeName: 'SiteOverview', section: 'overview', icon: 'fa fa-compass' },
	{ label: '办公室', routeName: 'Office', section: 'office', icon: 'fa fa-comments-o', requiresAuth: true },
	{ label: '财税', routeName: 'Home', section: 'finance', icon: 'fa fa-building-o', requiresAuth: true },
	{ label: '人事', section: 'hr', icon: 'fa fa-users', requiresAuth: true, comingSoon: true },
	{ label: '法务', section: 'legal', icon: 'fa fa-gavel', requiresAuth: true, comingSoon: true },
	{ label: '产研', section: 'product', icon: 'fa fa-flask', requiresAuth: true, comingSoon: true },
	{ label: '员工市场', routeName: 'EmployeeMarket', section: 'market', icon: 'fa fa-th-large' },
	{ label: '文档', routeName: 'Docs', section: 'docs', icon: 'fa fa-book' },
	{ label: '关于', routeName: 'About', section: 'about', icon: 'fa fa-info-circle' }
]);

const buildFinanceGroups = role => {
	const menus = menuConfig[role] || menuConfig.Manager;
	const quickItems = [];
	const groups = [];

	menus.forEach(item => {
		if (item.children && item.children.length) {
			groups.push({
				title: item.title,
				icon: item.icon,
				items: item.children.map(child => ({
					title: child.title,
					routeName: child.key,
					icon: item.icon
				}))
			});
			return;
		}
		quickItems.push({
			title: item.title,
			routeName: item.key,
			icon: item.icon
		});
	});

	if (quickItems.length) {
		groups.unshift({
			title: '工作区',
			icon: 'fa fa-briefcase',
			items: quickItems
		});
	}

	return groups;
};

export const getSidebarGroups = (section, options = {}) => {
	const isAuthenticated = options.isAuthenticated === true;
	const role = options.role || 'Manager';

	switch (section) {
		case 'overview':
			return [
				{
					title: '站点导航',
					icon: 'fa fa-sitemap',
					items: [
						{ title: '首页', routeName: 'SiteOverview', icon: 'fa fa-home' },
						{ title: '员工市场', routeName: 'EmployeeMarket', icon: 'fa fa-th-large' },
						{ title: '文档中心', routeName: 'Docs', icon: 'fa fa-book' }
					]
				},
				{
					title: '进入业务',
					icon: 'fa fa-rocket',
					items: [
						{ title: '办公室', routeName: 'Office', icon: 'fa fa-comments-o' },
						{ title: '财税后台', routeName: 'Home', icon: 'fa fa-line-chart' }
					]
				}
			];
		case 'office':
			return [
				{
					title: '办公室',
					icon: 'fa fa-comments-o',
					items: [
						{ title: 'AI 办公台', routeName: 'Office', icon: 'fa fa-commenting-o' },
						{ title: 'XSender 集成', routeName: 'Office', hash: '#xsender', icon: 'fa fa-plug' },
						{ title: '快捷模版', routeName: 'Office', hash: '#templates', icon: 'fa fa-magic' }
					]
				}
			];
		case 'market':
			return [
				{
					title: '员工市场',
					icon: 'fa fa-th-large',
					items: [
						{ title: '全部员工', routeName: 'EmployeeMarket', icon: 'fa fa-users' },
						{ title: '财务数字员工', routeName: 'EmployeeMarket', query: { category: 'finance' }, icon: 'fa fa-calculator' },
						{ title: 'HR数字员工', routeName: 'EmployeeMarket', query: { category: 'hr' }, icon: 'fa fa-users' },
						{ title: '法务数字员工', routeName: 'EmployeeMarket', query: { category: 'legal' }, icon: 'fa fa-gavel' },
						{ title: '数据专员', routeName: 'EmployeeMarket', query: { category: 'data' }, icon: 'fa fa-database' }
					]
				}
			];
		case 'docs':
			return [
				{
					title: '文档与支持',
					icon: 'fa fa-book',
					items: [
						{ title: '文档中心', routeName: 'Docs', icon: 'fa fa-files-o' },
						{ title: 'XSender 文档', external: 'https://jianfv.top/XSender/guide/install', icon: 'fa fa-external-link' },
						{ title: '关于平台', routeName: 'About', icon: 'fa fa-info-circle' }
					]
				}
			];
		case 'about':
			return [
				{
					title: '关于',
					icon: 'fa fa-info-circle',
					items: [
						{ title: '平台简介', routeName: 'About', icon: 'fa fa-building' },
						{ title: '文档中心', routeName: 'Docs', icon: 'fa fa-book' },
						{ title: '首页', routeName: 'SiteOverview', icon: 'fa fa-home' }
					]
				}
			];
		case 'finance':
			if (!isAuthenticated) {
				return [];
			}
			return buildFinanceGroups(role);
		default:
			return [];
	}
};
